(function() {
  const CACHE_VALIDATION = {};
  
  async function validateCart() {
    // Evita execução simultânea
    if (window.__CONJUNTO_VALIDATING__) return false;
    window.__CONJUNTO_VALIDATING__ = true;

    try {
      // 1. Obter estado atual do carrinho
      const res = await fetch('/cart.js');
      if (!res.ok) {
         window.__CONJUNTO_VALIDATING__ = false;
         return false;
      }
      const cart = await res.json();
      
      const itemsToRemove = [];
      const parentsToValidate = new Set();
      
      // 2. Identificar conjuntos que precisam ser validados
      cart.items.forEach(item => {
        if (item.properties && item.properties['_conjunto_parent']) {
           parentsToValidate.add(item.properties['_conjunto_parent']);
        }
      });
      
      if (parentsToValidate.size === 0) {
         window.__CONJUNTO_VALIDATING__ = false;
         return false;
      }
      
      // 3. Validar cada conjunto
      for (const parentHandle of parentsToValidate) {
        let validIds = CACHE_VALIDATION[parentHandle];
        
        // Verifica se cache expirou ou não existe (opcional, aqui mantendo simples)
        if (!validIds) {
          try {
            const url = `/products/${parentHandle}?view=conjunto-validation&t=${Date.now()}`; // timestamp para evitar cache de browser
            const valRes = await fetch(url);
            
            if (valRes.status === 404) {
              // Produto pai não existe mais -> todos os itens são inválidos
              validIds = []; 
            } else if (valRes.ok) {
              // Tenta parsear JSON
              try {
                const data = await valRes.json();
                // Se has_conjunto for false, o conjunto foi desfeito/removido
                if (!data.has_conjunto) {
                  validIds = [];
                } else {
                  validIds = data.valid_variant_ids || [];
                }
              } catch (jsonErr) {
                console.warn('[Conjunto Validator] Resposta inválida (não-JSON) para', parentHandle);
                // Fail-safe: se não conseguimos validar, não removemos nada
                continue; 
              }
            } else {
              // Erro de servidor ou outro status -> ignorar
              continue;
            }
            
            CACHE_VALIDATION[parentHandle] = validIds;
          } catch (e) {
            console.error('[Conjunto Validator] Erro ao buscar validação para', parentHandle, e);
            continue;
          }
        }
        
        // 4. Marcar itens inválidos para remoção
        const itemsOfParent = cart.items.filter(item => item.properties && item.properties['_conjunto_parent'] === parentHandle);
        
        itemsOfParent.forEach(item => {
           // Se a variante não está na lista de IDs válidos do conjunto atual
           if (!validIds.includes(item.variant_id)) {
             const isGift = item.properties && item.properties['_is_conjunto_gift'] === 'true';
             const typeLabel = isGift ? 'BRINDE' : 'ITEM';
             
             console.log(`[Conjunto Validator] Removendo ${typeLabel} de conjunto obsoleto/inválido: ${item.title} (Key: ${item.key}) - Origem: ${parentHandle}`);
             console.log(`[Conjunto Validator] Nota: Itens idênticos de outros fluxos (sem a tag _conjunto_parent) não serão afetados.`);
             
             itemsToRemove.push(item.key);
           }
        });
      }
      
      // 5. Executar remoção se necessário
      if (itemsToRemove.length > 0) {
        console.log('[Conjunto Validator] Removendo itens:', itemsToRemove);
        
        const updates = {};
        itemsToRemove.forEach(key => {
          updates[key] = 0;
        });
        
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        
        // Recarregar para refletir mudanças
        window.location.reload();
        return true;
      }
      
    } catch (e) {
      console.error('[Conjunto Validator] Erro fatal na validação', e);
    } finally {
      window.__CONJUNTO_VALIDATING__ = false;
    }
    
    return false;
  }
  
  // Debounce helper
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  const debouncedValidate = debounce(validateCart, 1000);

  // Gatilhos de execução:
  
  // 1. Ao carregar a página (DOMContentLoaded)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateCart);
  } else {
    validateCart();
  }

  // 2. Ao voltar para a aba/janela (visibilitychange e focus)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      validateCart();
    }
  });
  window.addEventListener('focus', validateCart);
  
  // 3. Ao restaurar a página do cache (bfcache - botão voltar do navegador)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      validateCart();
    }
  });

  // 4. Interceptar clique em botões de checkout
  document.addEventListener('click', async (e) => {
    const target = e.target;
    const checkoutBtn = target.closest('[name="checkout"], a[href="/checkout"], .cart-summary__checkout');
    
    if (checkoutBtn) {
       // Se já validamos este botão especificamente, deixa passar
       if (checkoutBtn.dataset.conjuntoValidated === 'true') {
         return;
       }
       
       // Impede a navegação imediata
       e.preventDefault();
       e.stopPropagation();
       
       // Feedback visual
       const originalOpacity = checkoutBtn.style.opacity;
       checkoutBtn.style.opacity = '0.5';
       checkoutBtn.style.cursor = 'wait';
       
       // Executa validação e aguarda
       // Se já houver validação rodando (window.__CONJUNTO_VALIDATING__),
       // o validateCart retornará false imediatamente para evitar sobreposição,
       // mas precisamos saber se devemos esperar ou se podemos prosseguir.
       // Melhor forçar esperar se já estiver rodando.
       
       let itemsRemoved = false;
       if (window.__CONJUNTO_VALIDATING__) {
          // Aguarda um pouco e tenta de novo ou assume que vai recarregar se necessário?
          // Simplificação: vamos assumir que se está rodando, algo pode mudar.
          // Mas como o validateCart retorna false se estiver rodando, precisamos
          // evitar o clique duplo.
          console.log('[Conjunto Validator] Validação em andamento, aguardando...');
          return; 
       }
       
       itemsRemoved = await validateCart();
       
       if (itemsRemoved) {
         // Se removeu itens, o validateCart já chamou reload().
         console.log('[Conjunto Validator] Itens removidos antes do checkout. Recarregando...');
       } else {
         // Se nada foi removido, libera o clique
         checkoutBtn.dataset.conjuntoValidated = 'true';
         checkoutBtn.style.opacity = originalOpacity || '';
         checkoutBtn.style.cursor = '';
         
         // Re-dispara o clique no elemento original (para garantir forms submit)
         checkoutBtn.click();
       }
    }
  });

  
})();
